'use strict';
angular.module('theme').directive('uniqueEmail', function () {
	return {
		require: 'ngModel',
		link: function(scope, element, attributes, ngModel) {
			ngModel.$asyncValidators.uniqueEmail = function () {
				return true;
			};
		}
	};
});
